<template>
    <section class="login-section">
      <div class="login-box">
        <a href="#" class="link-block-63 w-inline-block">
          <img loading="lazy" src="@/assets/images/Rx-Pros-icon-web.png" alt="" class="image-555">
        </a>
        <div class="first-slide">
          <div class="header-sub-div">
            <div class="register-header">Great to see you again.</div>
            <div class="text-block-851">Let's get you logged in</div>
            <div class="text-block-203">New user? <router-link to="/quiz" class="link-12">take the quiz <span class="text-span-182">-&gt;</span></router-link>
            </div>
          </div>
          <div class="register-form w-form">
            <form @submit.prevent="onSubmit">
              <label for="email" class="label">Email Address</label>
              <input 
                class="register-text-field w-input" 
                maxlength="256" 
                name="email" 
                data-name="Email" 
                placeholder="" 
                type="email" 
                id="email" 
                required=""
                v-model="email"
              >
              <label for="Password" class="label">Password</label>
              <input 
                class="register-text-field w-input" 
                maxlength="256" 
                name="Password" 
                data-name="Password" 
                placeholder="" 
                type="password" 
                id="Password" 
                required=""
                v-model="password"
              >
              <button 
                type="submit"
                class="submit-button-13 w-button"
                :disabled="submitted"
              >
                <div v-if="submitted">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                  </svg>
                </div>
                <div v-else>
                  Next
                </div>
              </button>
              <div class="text-block-203">
                Forgot Password? <router-link to="/forgot-password" class="link-12">Click here to reset <span class="text-span-182">-&gt;</span></router-link>
              </div>
            </form>
            <div class="w-form-fail" style="display: block;" v-if="err">
              <div v-html="errmsg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
<script>
export default {
    name: 'LoginPage',
    props: ['baseUrl'],
    data() {
        return {
            email: null,
            password: null,
            submitted: false,
            err: false,
            errmsg: "",
            emailError: false,
        }
    },
    computed: {
        getUrl() {
            if (this.$route.query.page_ref) {
                return `/home?page_ref=${this.$route.query.page_ref}`
            } else {
                return "/home"
            }
        }
    },
    created() {
        // Remove any theme from dashboard - login page should always be light
        document.documentElement.removeAttribute('data-theme')

        // Redirect logged-in users away from login page
        if (this.$store.getters.isAuthenticated) {
            const pageRef = this.$route.query.page_ref
                ? this.extractFinalDestination(this.$route.query.page_ref)
                : '/home';
            this.$router.replace(pageRef);
        }

        // Prefill email: URL query param takes priority, then fall back to store
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const urlEmail = this.$route.query.email;
        if (urlEmail && emailRegex.test(urlEmail)) {
            this.email = urlEmail;
        } else {
            const user = this.$store.getters.user;
            if (user && user.email && emailRegex.test(user.email)) {
                this.email = user.email;
            }
        }
    },
    methods: {
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        validateEmail() {
            if (this.email && this.email.trim()) {
                this.emailError = !this.isValidEmail(this.email.trim());
            } else {
                this.emailError = false;
            }
        },
        extractFinalDestination(url) {
            // A 401 that lands while /login is on screen wraps the login URL in
            // another page_ref, each layer with its own &email=. Each layer is
            // read as a query string, so the emails stay parameters. Decoding it
            // all and matching text glued them onto the path, and the check-in
            // link came back as /home/checkin/track-progress&email=...
            let target = url;
            for (let depth = 0; depth < 20 && target; depth++) {
                if (!target.startsWith('/') && target.includes('%')) {
                    try {
                        target = decodeURIComponent(target);
                    } catch (e) {
                        return '/home';
                    }
                }
                const [path, query] = target.split('?');
                if (path !== '/login' && path !== 'login') {
                    return path || '/home';
                }
                target = new URLSearchParams(query || '').get('page_ref');
            }
            return '/home';
        },
        onSubmit() {
            this.validateEmail();
            if (this.emailError || !this.email || !this.email.trim()) {
                this.err = true;
                this.errmsg = "Please enter a valid email address.";
                return;
            }
            this.submitted = true;
            this.err = false;
            this.$axios.post(`${this.baseUrl}/api/login`, {
                password: this.password,
                email: this.email.toLowerCase(),
            }).then(async response => {
                if (response.data.status == 'success') {
                    this.$store.dispatch("doLogin", response.data);

                    // Fetch full user details (includes dob, shipping)
                    try {
                        const detailsResponse = await this.$axios.get(`${this.baseUrl}/api/current-user-details`);
                        if (detailsResponse.data.success && detailsResponse.data.user) {
                            this.$store.dispatch("UpdateUserData", detailsResponse.data.user);
                        }
                        if (detailsResponse.data.shipping) {
                            this.$store.dispatch("saveShippingDetails", detailsResponse.data.shipping);
                        }
                    } catch (err) {
                        console.error('Failed to fetch user details:', err);
                    }

                    const pageRef = this.$route.query.page_ref
                        ? this.extractFinalDestination(this.$route.query.page_ref)
                        : '/home';
                    this.$router.push(pageRef);
                } else {
                    this.submitted = false;
                    this.err = true;
                    this.errmsg = response.data.message;
                }
            }).catch(error => {
                console.log(error.message)
                this.submitted = false;
                this.err = true;
                // v-html renders plain HTML only: a <router-link> here is a dead tag.
                this.errmsg = 'Email or password entered is incorrect. Please try again or <a href="/forgot-password" class="link-12">reset your password.</a>'
            });

        },
    }
}
</script>
  
  <style scoped>
  /* You can add any additional styles here if needed */
  </style>